@if (visible()) {
  <div class="background-designer" [class.background-designer--collapsed]="!isOpen()">
    <button
      class="background-designer__toggle"
      type="button"
      title="Ajustar background"
      aria-label="Ajustar background"
      (click)="togglePanel()">
      <i class="pi" [class.pi-sliders-h]="!isOpen()" [class.pi-times]="isOpen()"></i>
    </button>

    @if (isOpen()) {
      <div class="background-designer__panel">
        <div class="background-designer__header">
          <strong>Background</strong>
          <button
            type="button"
            title="Restaurar ajustes"
            aria-label="Restaurar ajustes"
            (click)="reset()">
            <i class="pi pi-refresh"></i>
          </button>
        </div>

        <div class="background-designer__field">
          <app-select
            [options]="imageOptions"
            [selectedOption]="selectedImage()"
            [virtualScroll]="false"
            [hasFilter]="false"
            [label]="'Imagem'"
            [scrollHeight]="'240px'"
            (sendSelectedOption)="handleImageChange($event)"></app-select>
        </div>

        <div class="background-designer__field">
          <app-select
            [options]="sizeOptions"
            [selectedOption]="selectedSize()"
            [virtualScroll]="false"
            [hasFilter]="false"
            [label]="'Estilo'"
            [scrollHeight]="'160px'"
            (sendSelectedOption)="handleSizeChange($event)"></app-select>
        </div>

        <div class="background-designer__field">
          <app-select
            [options]="effectOptions"
            [selectedOption]="selectedEffect()"
            [virtualScroll]="false"
            [hasFilter]="false"
            [label]="'Efeito do cursor'"
            [scrollHeight]="'180px'"
            (sendSelectedOption)="handleEffectChange($event)"></app-select>
        </div>

        <label class="background-designer__range">
          <span>Horizontal {{ positionX() }}%</span>
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="positionX()"
            (ngModelChange)="updatePositionX($event)" />
        </label>

        <label class="background-designer__range">
          <span>Overlay {{ overlay() }}%</span>
          <input
            type="range"
            min="0"
            max="80"
            [ngModel]="overlay()"
            (ngModelChange)="updateOverlay($event)" />
        </label>

        <label class="background-designer__range">
          <span>Blur {{ blur() }}px</span>
          <input
            type="range"
            min="0"
            max="12"
            [ngModel]="blur()"
            (ngModelChange)="updateBlur($event)" />
        </label>
      </div>
    }
  </div>
}
